var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScreenTimeIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Screen_Time_icon_svg__clip0_2002_412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M745 164.976H255c-13.807 0-25 11.193-25 25v256.25c0 13.807 11.193 25 25 25h490c13.807 0 25-11.193 25-25v-256.25c0-13.807-11.193-25-25-25z",
    fill: "#006C78",
    stroke: "#006C78",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.5 202.476h-465v231.25h465v-231.25z",
    fill: "#40A9D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.012 443.107h219.964c-.357-34.571-28.488-62.5-63.143-62.5h-93.678c-34.667 0-62.786 27.929-63.143 62.5z",
    fill: "#F93444",
    stroke: "#FA505E",
    strokeWidth: 16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 396.583c45.662 0 82.679-37.016 82.679-82.678S545.662 231.226 500 231.226s-82.679 37.017-82.679 82.679 37.017 82.678 82.679 82.678z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.464 344.928c-8.321 8.322-19.797 13.465-32.464 13.465-12.667 0-24.143-5.155-32.464-13.465",
    stroke: "#FA505E",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.036 289.5v22.964M522.964 289.5v22.964",
    stroke: "#2A838D",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.5 202.476v231.25h-465v-231.25h465zm0-19.048h-465c-10.524 0-19.048 8.524-19.048 19.048v231.25c0 10.524 8.524 19.048 19.048 19.048h465c10.524 0 19.048-8.524 19.048-19.048v-231.25c0-10.524-8.524-19.048-19.048-19.048z",
    fill: "#006C78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.548 180.845h300.821",
    stroke: "#2A848E",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745 530.155H255c-13.807 0-25 11.193-25 25v250c0 13.807 11.193 25 25 25h490c13.807 0 25-11.193 25-25v-250c0-13.807-11.193-25-25-25z",
    fill: "#2A848E",
    stroke: "#236D75",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745 490.155H255c-13.807 0-25 11.193-25 25v250c0 13.807 11.193 25 25 25h490c13.807 0 25-11.193 25-25v-250c0-13.807-11.193-25-25-25z",
    fill: "#95C2C7",
    stroke: "#2A848E",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.821 790.155H653.69",
    stroke: "#CAE0E3",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710 530.155V676.81h-70v-73.322h-70v-73.333h140zM500 530.155h-70v73.333h70v-73.333zM430 530.155h-70v73.333h70v-73.333zM360 530.155h-70v73.333h70v-73.333zM570 603.488H360v73.322h210v-73.322z",
    fill: "#2A848E",
    stroke: "#236D75",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 603.488h-70v73.322h70v-73.322zM570 530.155h-70v73.333h70v-73.333zM360 603.488h-70v73.322h70v-73.322z",
    fill: "#2A848E",
    stroke: "#236D75",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610 676.81H390v73.333h220V676.81z",
    fill: "#95C2C7",
    stroke: "#236D75",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Screen_Time_icon_svg__clip0_2002_412"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1000v1000H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenTimeIcon);
export default ForwardRef;